<template>
  <!-- Modal -->
  <div class="modal fade" id="pcr_upload" tabindex="-1" role="dialog" aria-labelledby="pcr_upload_title" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <form @submit.prevent="upload()" enctype="multipart/form-data">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold" id="pcr_upload_title">Add PCR Certificate</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-left">
            <div class="form-group">
              <label class="mb-0" for="pcr_file">
                <span class="tnkc-danger-text">*</span>
                Upload PCR Certificate:
              </label>
              <input type="file" class="form-control p-1" id="pcr_file" required>
            </div>
            <div class="form-group">
              <label class="mb-0" for="pcr_swab_date">
                <span class="tnkc-danger-text">*</span>
                Swab Date:
              </label>
              <input class="form-control" id="pcr_swab_date" type="date" required v-model="pcr_swab_date">
            </div>
            <div class="form-group">
              <label class="mb-0" for="pcr_result_date">
                <span class="tnkc-danger-text">*</span>
                Result Date:
              </label>
              <input class="form-control" id="pcr_result_date" type="date" required v-model="pcr_result_date">
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn tnkc-secondary" data-dismiss="modal">
              <font-awesome-icon icon="times"/>
              Cancel
            </button>
            <button type="submit" class="btn tnkc-primary">
              <font-awesome-icon icon="file-upload"/>
              Upload
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {appMixins} from '@/mixins/app.mixins';
import {mapActions} from 'vuex';

export default {
  name: "PCR_upload",
  mixins:[appMixins],
  props: {
    crew_id : Number
  },
  data() {
    return {
      pcr_swab_date: '',
      pcr_result_date: '',
    }
  },
  methods: {
    ...mapActions(['uploadCov19MedCert','getCrewPCRS']),
    async upload(){
      if(await this.questionAlert('Are you sure you want to upload this document.','UPLOAD')){
        const file = document.getElementById('pcr_file').files[0];
        this.pcr_swab_date = document.getElementById('pcr_swab_date').value;
        this.pcr_result_date = document.getElementById('pcr_result_date').value;
        const formData = new FormData();
        formData.append('pcr_swab_date',this.pcr_swab_date);
        formData.append('pcr_result_date',this.pcr_result_date);
        formData.append('crew_id',this.crew_id);
        formData.append('file',file);
        this.uploadCov19MedCert(formData).then((response)=>{
          if(response == true){
            this.successAlert('Upload Successfully','Upload');
            this.resetFileInput();
          }
        }).catch((error)=>{});
      }
    },

    resetFileInput(){
      document.getElementById('pcr_file').value = '';
      document.getElementById('pcr_swab_date').value = '';
      document.getElementById('pcr_result_date').value = '';
      $('#pcr_upload').modal('hide');
      this.getCrewPCRS(this.crew_id);
    },
  },
}
</script>

<style scoped>

</style>